import { IReportNhapHocRequest } from "../../../model/request/report/IReportNhapHocRequest";
import { IPagingResult } from "../../../model/respone/IPagingResult";
import { IReportNhapHocRespone } from "../../../model/respone/report/IReportNhapHocRespone";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eReportNhapHocActionsObj = {
  LOAD_START: {} as IReportNhapHocRequest,
  LOAD_SUCCESS: {} as IPagingResult<IReportNhapHocRespone[]>,
  LOAD_ERROR: {} as string,
  CHANGE_REPORT_FILTER: "",
  CHANGE_REQUEST: {} as any,
  CHANGE_SINHVIEN_FILTER: "",
  SHOW_MODAL_LIST_BIEN_LAI: "",
  CLOSE_MODAL_LIST_BIEN_LAI: undefined,
  SHOW_HIDE_FILTER: {} as boolean,

  EXPORT_EXCEL_BAO_CAO_START: {} as IReportNhapHocRequest,
  EXPORT_EXCEL_BAO_CAO_SUCCESS: "",
  EXPORT_EXCEL_BAO_CAO_ERRR: "",
};
export const eReportNhapHocActionIds = generateActionTypeIds(
  eReportNhapHocActionsObj,
  "REPORT_NHAP_HOC"
);
export type IReportNhapHocActionTypes = IGenericActionType<
  typeof eReportNhapHocActionsObj,
  "REPORT_NHAP_HOC"
>;
